import React, {useState} from 'react'
import './style.css'
import {Link} from "react-router-dom";

export const Header=({navigation})=>{
    return (<div className='header-v1'>
        <Navigation {...navigation}/>
    </div>)
}
export const Navigation=(navigation)=>{
    const [currentPage,setCurrentPage]=useState(navigation[0].name)
    return (<div className='navigation'>
        {Object.values(navigation).map(nav=> <Menu key={nav.name} className={currentPage!==nav.name?'menu':'menu-selected'} currentPage={setCurrentPage} {...nav}/>)}
    </div>)
}

export const Menu=({className,name,link,currentPage})=>{
   return (<Link className={className} to={link} onClick={(ev)=>{currentPage(name)}}>{name}</Link>)
}

export const NotificationBanner=({messages})=>{
    return (<div className='top-banner' style={{background:messages.incident.style}}>{messages.incident.message}</div> )
}